<h2>Asset types</h2>
<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    [hasDetailView]="true">
</acabim-datatable>

<p-footer class="cas-action-buttons">
    <button type='button' (click)="onAddAssetType()">Add asset type</button>
</p-footer>

<acabim-modal
        [display]="addAssetTypeModal"
        [title]="'Add asset type details'"
        (status)="setAddAssetTypeModal($event)"
        [footer]="false"
        width="80vw"
        height="80vh"
>
    <acabim-admin-add-asset-type
            *ngIf="addAssetTypeModal"
            actionType="add"
            actionButtonLabel="Add"
            (completed)="onAddCompletion($event)">
    </acabim-admin-add-asset-type>
</acabim-modal>

<ng-template [ngIf]="dataSources[0].showDetails">
    <acabim-modal
            [display]="true"
            [title]="'Edit asset type details'"
            (status)="setEditAssetTypeModal($event)"
            [footer]="false"
            width="70vw"
    >
        <acabim-admin-update-asset-type
                [assetTypeDetails]="dataSources[0].detailData"
                (completed)="onEditCompletion($event)">
        </acabim-admin-update-asset-type>
    </acabim-modal>
</ng-template>
